import React, { useState } from 'react'
import './AddCareerContainer.scss';
import { FormControl, Input, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import { createCareer } from '../../data/api';
import { Bounce, ToastContainer, toast } from 'react-toastify';


export const AddCareerContainer = ({toggleAddCareer}) => {

    const [career, setCareer] = useState('');
    const [careerName, setCareerName] = useState('');

    const handleChange = (event) => {
        setCareer(event.target.value);
    };

    const handleName = (event) => {
        setCareerName(event.target.value);
    };

    const handleSubmit = async (event) => {

        if(careerName == ''){
            toast.error('Elige un nombre para la carrera', {
                position: "bottom-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
                theme: "dark",
                transition: Bounce,
                });
            return
        }
        let content = {}
        switch (career) {
            case 'industrial':
                content = require('../../data/industrial.json')
                break;
            case 'mecanica':
                content = require('../../data/mecanica.json')
                break;
            case 'quimica':
                content = require('../../data/quimica.json')
                break;
            case 'electronica':
                content = require('../../data/electronica.json')
                break;
            case 'electronica1995':
                content = require('../../data/electronica1995.json')
                break;
            case 'civil':
                content = require('../../data/civil.json')
                break;
            case 'electrica':
                content = require('../../data/electrica.json')
                break;
            default:
                toast.error('Elige una carrera', {
                    position: "bottom-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: true,
                    progress: undefined,
                    theme: "dark",
                    transition: Bounce,
                    });
                return
        }
        const car = {
            name: careerName,
            content: content,
            exceptionMode: false
        }

        const resp = await createCareer(localStorage.getItem('userId'), car)
        if(resp.status === 'success'){
            toast.success('¡Carrera creada!', {
                position: "bottom-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
                theme: "dark",
                transition: Bounce,
                });

            // Recargar la página después de 1 segundo
            setTimeout(() => {
                window.location.reload();
            }, 1000);
        }
    }

    return (
        <div className='add-career-background'>
            <div className='add-career-container'>
                <h3>Agregar carrera</h3>
                <div className='add-career-hr'></div>
                <FormControl>

                    <InputLabel style={{margin: 10, fontFamily: 'Sofia Sans, sans-serif'}} id="demo-simple-select-label">Elegir carrera</InputLabel>
                    <Select
                    labelId='demo-simple-select-label'
                    id="demo-simple-select-label"
                    value={career}
                    onChange={handleChange}
                    style={{margin: 10}}
                    >
                        <MenuItem style={{fontFamily: 'Sofia Sans, sans-serif'}} value={"electronica1995"}>Ingeniería Electrónica (Plan 1995)</MenuItem>
                        <MenuItem style={{fontFamily: 'Sofia Sans, sans-serif'}} value={"electronica"}>Ingeniería Electrónica (Plan 2023)</MenuItem>
                        <MenuItem style={{fontFamily: 'Sofia Sans, sans-serif'}} value={"civil"}>Ingeniería Cívil (Plan 2023)</MenuItem>
                        <MenuItem style={{fontFamily: 'Sofia Sans, sans-serif'}} value={"electrica"}>Ingeniería Eléctrica (Plan 2023)</MenuItem>
                        <MenuItem style={{fontFamily: 'Sofia Sans, sans-serif'}} value={"quimica"}>Ingeniería Química (Plan 2023)</MenuItem>
                        <MenuItem style={{fontFamily: 'Sofia Sans, sans-serif'}} value={"mecanica"}>Ingeniería Mecánica (Plan 2023)</MenuItem>
                        <MenuItem style={{fontFamily: 'Sofia Sans, sans-serif'}} value={"industrial"}>Ingeniería Industrial (Plan 2023)</MenuItem>
                        {/* <MenuItem style={{fontFamily: 'Sofia Sans, sans-serif'}} value={"Ingeniería Eléctrica"}>Ingeniería Eléctrica</MenuItem>
                        <MenuItem style={{fontFamily: 'Sofia Sans, sans-serif'}} value={"Ingeniería Cívil"}>Ingeniería Cívil</MenuItem>
                        <MenuItem style={{fontFamily: 'Sofia Sans, sans-serif'}} value={"Ingeniería Mecánica"}>Ingeniería Mecánica</MenuItem>
                        <MenuItem style={{fontFamily: 'Sofia Sans, sans-serif'}} value={"Ingeniería Industrial"}>Ingeniería Industrial</MenuItem>
                        <MenuItem style={{fontFamily: 'Sofia Sans, sans-serif'}} value={"Ingeniería Química"}>Ingeniería Química</MenuItem> */}
                    </Select>
                    <TextField style={{margin: 10, fontFamily: 'Sofia Sans, sans-serif'}} value={careerName} id="outlined-basic" label="Nombre" onChange={handleName} variant="outlined" />
                </FormControl>
                <button className="btn-create" onClick={handleSubmit}>Crear carrera</button>
                <button className='btn-cancel' onClick={toggleAddCareer}>Cancelar</button>
            </div>
            <ToastContainer />
        </div>
    )
}
